import { useState } from 'react'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Image from 'react-bootstrap/Image'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Logo from '../../assets/logo/logo.png'
import { Button } from 'react-bootstrap'
import { REDIRECT_URL } from '../../utils/constants'

function NavbarOffcanvas({ showMenu, setShowMenu }) {
  const location = useLocation()
  const navigate = useNavigate()
  // const [showMenu, setShowMenu] = useState(false)
  const onClick = () => {
    setShowMenu(false)
    navigate('/contact')
    // window.scrollTo({ bottom: 0, behavior: 'smooth' })
  }
  const redirectUrl = () => {
    // redirect to an external login
    window.location.href = REDIRECT_URL
  }
  const className = (path = '/products') =>
    ` px-2 ${
      (path !== '/' && location.pathname.startsWith(path)) ||
      location.pathname === path
        ? 'text-active text-bold'
        : 'text-white'
    }`
  return (
    <Navbar.Offcanvas show={showMenu} placement='start' id='responsive-navbar-nav' style={{ backgroundColor: '#495C2D' }} >
      <div>
        <Offcanvas.Header closeButton onClick={() => setShowMenu(false)}>
          <div className='w-100'>
            <Link to={'/'}>
              <Image style={{ width: '100%' }} src={Logo} />
            </Link>
            <hr className='mb-0' />
          </div>
        </Offcanvas.Header>
        <Nav className='gap-3 align-items-center'>
          <Link className={className('/')} to={'/'} onClick={() => setShowMenu(false)}>
            Home
          </Link>
          <Link className={className('/products')} to={'/products'} onClick={() => setShowMenu(false)}>
            Products
          </Link>
          <Link className={className('/documents')} to={'/documents'} onClick={() => setShowMenu(false)}>
            Documents
          </Link>
          <Link className={className('/about')} to={'/about'} onClick={() => setShowMenu(false)}>
            About Us
          </Link>
          <Button
            onClick={onClick}
            variant='success'
            className='navbar-link px-2 text-white'
          >
            Contact Us
          </Button>
          <Button onClick={redirectUrl} variant='danger' className='navbar-link px-2 text-white'>
            Login
          </Button>
        </Nav>
      </div>
    </Navbar.Offcanvas>
  )
}

export default NavbarOffcanvas
